import { handlePostAction } from "../../../utils/event-api-invoke";
import { getZoneAPIPostSchema, getZoneAuditInfoSchema } from "../create/Schema";

let _isError = false;

const getAuditInfo = (data, auditConfig) => {
  try {
    let _auditSchema = getZoneAuditInfoSchema();
    let _currentState = {};
    let _prevState = {};
    let _isDeleted = data?.Deleted;
    Object.keys(data).forEach((key) => {
      if (_isDeleted) {
        if (key !== "Deleted") { //We do not send deleted key in state
          switch (key) {
            case "ZoneName":
              _prevState.ZoneName = data[key];
              break;
            case "Location":
              _prevState.Location = data[key];
              break;
            default:
              break;
          }
        }
      } else {
        switch (key) {
          case "ZoneName":
            _currentState.ZoneName = data[key];
            _prevState.ZoneName = auditConfig.formdata?.[key];
            break;
          case "Location":
            _currentState.Location = data[key].label ? data[key].label : data[key];
            _prevState.Location = auditConfig.formdata?.[key].label ? auditConfig.formdata?.[key].label : auditConfig.formdata?.[key];
            break;
          default:
            break;
        }
      }
    });

    _auditSchema.auditInfo[0].shortDesc = data?.ZoneName;
    _auditSchema.auditInfo[0].currentState = JSON.stringify(_currentState);
    if (auditConfig.editZoneLocationId) {
      _auditSchema.auditInfo[0].LocationKey = auditConfig.editZoneLocationId;
      _auditSchema.auditInfo[0].Action = _isDeleted ? "DELETE" : "EDIT";
      _auditSchema.auditInfo[0].previousState = JSON.stringify(_prevState);
    } else {
      _auditSchema.auditInfo[0].Action = "CREATE";
    }

    return _auditSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getPostPayload = (data, config) => {
  try {
    let _postSchema = getZoneAPIPostSchema(config.countryCode, config.businessCode);

    _postSchema.zonelocation[0].Location = data?.Location?.label;
    _postSchema.zonelocation[0].LocationId = data?.Location?.id;
    _postSchema.zonelocation[0].ZoneName = data?.ZoneName;
    if (config.editZoneLocationId) {
      _postSchema.zonelocation[0].ZoneLocationId = config.editZoneLocationId;
      _postSchema.zonelocation[0].Deleted = data.Deleted ? data.Deleted : false;
    }

    return _postSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const saveZone = async (data, uihandler) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  const {
    EditZoneLocationId: editZoneLocationId,
    settingsConfig: { businessCode, countryCode },
    formdata,
  } = uihandler;
  try {
    let _auditInfo = getAuditInfo(data, { editZoneLocationId, formdata });
    let _postPayload = getPostPayload(data, { editZoneLocationId, businessCode, countryCode });

    let _postRequest = { ..._postPayload, ..._auditInfo };

    let res = await handlePostAction(_postRequest, "zone");
    if (res && res.status && res.status === 200) {
      if (res.data.errorNumber > 0) {
        _isError = true;
        status.errorMessage = res.data.errorDescription;
      } else {
        status.responseStatus = res.status;
      }
    }
  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

export { saveZone };
